import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'foundations-theming/utils';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FullSizeContainer = styled.div.withConfig({
  displayName: "DataExplorerEmptyState__FullSizeContainer",
  componentId: "sc-1osjy8e-0"
})(["display:table;position:absolute;top:0;left:0;height:100%;width:100%;"]);
const CenteredContent = styled.div.withConfig({
  displayName: "DataExplorerEmptyState__CenteredContent",
  componentId: "sc-1osjy8e-1"
})(["display:table-cell;vertical-align:middle;"]);
const DataExplorerEmptyState = props => {
  const {
    message
  } = props;
  return /*#__PURE__*/_jsx(FullSizeContainer, {
    children: /*#__PURE__*/_jsx(CenteredContent, {
      children: /*#__PURE__*/_jsx(ResultsMessage, {
        illustration: "empty-state-charts",
        margin: "0",
        padding: "400",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })
      })
    })
  });
};
export default DataExplorerEmptyState;